module.exports = __webpack_public_path__ + "img/pre-bg1.0bd1b062.png";